import { notification } from 'antd'
import { useCallback, useContext, useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { OrganizationContext } from '@BUP/contexts/OrganizationContext'
import { useTranslation } from 'react-i18next'
import { useApiMutation } from '@BUP/hooks/useApiMutation'

export const useCreateEnrollment = () => {
  const organization = useContext(OrganizationContext)
  const queryClient = useQueryClient()
  const [error, setError] = useState(null)
  const [enrollment, setEnrollment] = useState(null)
  const i18n = useTranslation()

  const mutation = useApiMutation(
    'schools',
    'enrollments',
    'post',
    {
      onSuccess: data => {
        queryClient.removeQueries({ queryKey: ['enrollments-by-role-type'], type: 'inactive' })
        queryClient.invalidateQueries({ queryKey: ['enrollments-by-role-type'] })

        notification.info({
          style: { fontWeight: 500, fontSize: 17 },
          message: i18n.t('common.resources.user.actions.create.success'),
          duration: 5
        })
        setEnrollment(data)
      },
      onError: error => {
        setError(error)
      }
    },
    { authenticated: true, version: 3 }
  )
  const { mutateAsync } = mutation

  const createEnrollment = useCallback(async formValues => {
    const { name, email, password, mainTeacher, roleType } = formValues

    setError(null)
    return mutateAsync({
      data: {
        role: {
          type: roleType
        },
        organizationId: organization.id,
        user: {
          email,
          name,
          password
        },
        main_teacher: mainTeacher
      }
    })
      .catch(error => {
        console.error(error)
        return null
      })
  }, [mutateAsync, organization.id])

  return {
    loading: mutation.isPending,
    createEnrollment,
    enrollment,
    error,
    setError
  }
}
